import { clearNativeSessionToken, getNativeSessionToken } from './capacitor-session';

/** Attach bearer token and omit cookies on native auth API calls. */
export function withCapacitorAuthFetch(fetchImpl: typeof fetch): typeof fetch {
  return async (input, init) => {
    const url =
      typeof input === 'string' ? input : input instanceof URL ? input.href : input.url;

    if (url.includes('/sign-out')) {
      await clearNativeSessionToken();
    }

    const token = await getNativeSessionToken();
    const headers = new Headers(init?.headers);
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }

    return fetchImpl(input, {
      ...init,
      headers,
      credentials: 'omit',
    });
  };
}
